var _circle, _circle2, _path, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 76,
    viewBox: "0 0 56 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.25,
    cx: 21,
    cy: 15,
    r: 3,
    fill: "url(#paint0_linear_11_24343)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.25,
    cx: 34,
    cy: 15,
    r: 3,
    fill: "url(#paint1_linear_11_24343)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 5.5V4H31V5.5C31 7.433 29.433 9 27.5 9C25.567 9 24 7.433 24 5.5ZM22 3.62295C22 2.72662 22.7266 2 23.623 2H31.377C32.2734 2 33 2.72662 33 3.62295V5H37C39.7614 5 42 7.23858 42 10H44C45.6569 10 47 11.3431 47 13V17C47 18.6569 45.6569 20 44 20H41.9C41.4367 22.2822 39.419 24 37 24H33V27H42H44H45H46H48C51.866 27 55 30.134 55 34V35V37H53V50.5V51.5V52.5V55C53 57.2091 51.2091 59 49 59C46.7909 59 45 57.2091 45 55V52.5V51.5V50.5V37H44.9945C44.9077 40.8923 43.8063 44.2841 41.8655 47L42 46.8088V55C42 58.3137 39.3137 61 36 61H33V69C33 71.2091 31.2091 73 29 73H26C23.7909 73 22 71.2091 22 69V61H19C15.6863 61 13 58.3137 13 55V47H13.1345C12.2382 45.7458 11.521 44.3474 11 42.8222V50.5V51.5V52.5V55C11 57.2091 9.20914 59 7 59C4.79086 59 3 57.2091 3 55V52.5V51.5V50.5V37H1V35V34C1 30.134 4.13401 27 8 27H10H12H13H22V24H18C15.581 24 13.5633 22.2822 13.1 20H11C9.34315 20 8 18.6569 8 17L8 13C8 11.3431 9.34315 10 11 10L13 10C13 7.23858 15.2386 5 18 5H22V3.62295ZM15 49.1589V55C15 57.2091 16.7909 59 19 59H22V53.1723C19.2408 52.3331 16.8796 50.9675 15 49.1589ZM33 59H36C38.2091 59 40 57.2091 40 55V49.1589C38.1204 50.9675 35.7592 52.3331 33 53.1723V59ZM47 37H51V50.5H47V37ZM53 34V35H51H47H46V29H48C50.7614 29 53 31.2386 53 34ZM5 37H9V50.5H5V37ZM10 31V35H9H5H3V34C3 31.2386 5.23858 29 8 29H10V31ZM22 50.9959V49C22 46.7909 23.7909 45 26 45H29C31.2091 45 33 46.7909 33 49V50.9959C38.8454 48.7768 43 43.1236 43 36.5V31C43 30.4477 42.5523 30 42 30H13C12.4477 30 12 30.4477 12 31V35V36.5C12 43.1236 16.1546 48.7768 22 50.9959ZM24 27V24H31V27H24ZM37 22H33H31H24H22H18C16.3431 22 15 20.6569 15 19V10C15 8.34315 16.3431 7 18 7H22.207C22.86 9.30851 24.9824 11 27.5 11C30.0176 11 32.14 9.30851 32.793 7H37C38.6569 7 40 8.34315 40 10V19C40 20.6569 38.6569 22 37 22ZM11 12H13V18H11C10.4477 18 10 17.5523 10 17L10 13C10 12.4477 10.4477 12 11 12ZM42 12V18H44C44.5523 18 45 17.5523 45 17V13C45 12.4477 44.5523 12 44 12H42ZM24 49C24 47.8954 24.8954 47 26 47H29C30.1046 47 31 47.8954 31 49V69C31 70.1046 30.1046 71 29 71H26C24.8954 71 24 70.1046 24 69V49ZM9 52.5H5V55C5 56.1046 5.89543 57 7 57C8.10457 57 9 56.1046 9 55V52.5ZM47 52.5H51V55C51 56.1046 50.1046 57 49 57C47.8954 57 47 56.1046 47 55V52.5Z",
    fill: "url(#paint2_linear_11_24343)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.25,
    x: 19,
    y: 33,
    width: 17,
    height: 3,
    rx: 1.5,
    fill: "url(#paint3_linear_11_24343)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11_24343",
    x1: 18,
    y1: 16,
    x2: 24.0319,
    y2: 15.5853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#7A5DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11_24343",
    x1: 31,
    y1: 16,
    x2: 37.0319,
    y2: 15.5853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#7A5DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11_24343",
    x1: 1,
    y1: 49.3333,
    x2: 55.3953,
    y2: 46.4888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#7A5DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11_24343",
    x1: 19,
    y1: 35,
    x2: 33.9081,
    y2: 29.1914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#7A5DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB00FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot);
export default __webpack_public_path__ + "static/media/bot.b53ac587cde1b97b31a42b8d80e78dd1.svg";
export { ForwardRef as ReactComponent };